import { render, staticRenderFns } from "./MenuFavorites.vue?vue&type=template&id=7b1c4b62&scoped=true&"
import script from "./MenuFavorites.vue?vue&type=script&lang=js&"
export * from "./MenuFavorites.vue?vue&type=script&lang=js&"
import style0 from "./MenuFavorites.vue?vue&type=style&index=0&id=7b1c4b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1c4b62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem,VSheet})
